// extracted by mini-css-extract-plugin
export default {"container":"CarCheckFAQ-module__container-JwDv"};